// Create a Mockup. Hub linking to the customer-facing builders, with an
// "admin proof mode" hint. The builders themselves are the actual tool; this
// page is the on-ramp from the admin nav.
import { Link } from 'react-router-dom'

export default function CreateMockup() {
  return (
    <div className="p-8">
      <div className="mb-6">
        <div className="eyebrow">Production</div>
        <h1 className="font-heading uppercase font-bold text-3xl text-ink">Create a Mockup</h1>
        <p className="text-ink-2 text-sm mt-1 max-w-2xl">Open a builder to design a mockup for a customer pitch, marketing comp, or internal proof. Designs you create here are saved as drafts (kind = garment or dtf) and can be sent to the customer for approval.</p>
      </div>

      <div className="grid md:grid-cols-2 gap-6 max-w-3xl">
        <Link to="/designer" className="card hover:border-gold transition-colors block">
          <div className="eyebrow">Garment</div>
          <h2 className="font-heading uppercase font-bold text-xl text-ink">Garment Designer</h2>
          <p className="text-ink-2 text-sm mt-2">Place artwork on a mockup tee/long-sleeve/polo/hoodie. Pick colour + sizes + qty.</p>
          <div className="text-xs text-gold-dark mt-3">Open Designer →</div>
        </Link>
        <Link to="/dtf" className="card hover:border-gold transition-colors block">
          <div className="eyebrow">DTF</div>
          <h2 className="font-heading uppercase font-bold text-xl text-ink">DTF Builder</h2>
          <p className="text-ink-2 text-sm mt-2">Drop artwork onto a 57 cm rolling sheet. Per-image DPI feedback + multi-sheet pricing.</p>
          <div className="text-xs text-gold-dark mt-3">Open DTF →</div>
        </Link>
      </div>
    </div>
  )
}
